<h2 mat-dialog-title>{{ 'History' | translate }}: {{ data.title }}</h2>

<mat-dialog-content>
  @if (isHistoryLoading) {
    <div class="loading-wrap">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
  }

  @if (!isHistoryLoading && historyLoaded && historyDataSource.data.length === 0) {
    <div class="empty-wrap">
      {{ "No history yet — this record hasn't been changed since creation." | translate }}
    </div>
  }

  @if (!isHistoryLoading && historyDataSource.data.length > 0) {
    <table mat-table [dataSource]="historyDataSource"
      class="history-table"
      >
      <ng-container matColumnDef="dateUpdated">
        <th mat-header-cell *matHeaderCellDef>{{ 'Date Updated' | translate }}</th>
        <td mat-cell *matCellDef="let h">{{ h.dateUpdatedDisplay || '-' }}</td>
      </ng-container>
      <ng-container matColumnDef="updatedByUserName">
        <th mat-header-cell *matHeaderCellDef>{{ 'Changed By' | translate }}</th>
        <td mat-cell *matCellDef="let h">{{ h.updatedByUserName || '-' }}</td>
      </ng-container>
      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef>{{ 'Code' | translate }}</th>
        <td mat-cell *matCellDef="let h" [class.highlight]="isChanged(h, 'Code')">{{ h.code || '-' }}</td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>{{ 'Name' | translate }}</th>
        <td mat-cell *matCellDef="let h" [class.highlight]="isChanged(h, 'Name')">{{ h.name || '-' }}</td>
      </ng-container>
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>{{ 'Description' | translate }}</th>
        <td mat-cell *matCellDef="let h" [class.highlight]="isChanged(h, 'Description')">{{ h.description || '-' }}</td>
      </ng-container>
      <ng-container matColumnDef="isActive">
        <th mat-header-cell *matHeaderCellDef>{{ 'Active' | translate }}</th>
        <td mat-cell *matCellDef="let h" [class.highlight]="isChanged(h, 'Active')">{{ h.statusDisplay }}</td>
      </ng-container>
      <ng-container matColumnDef="reason">
        <th mat-header-cell *matHeaderCellDef>{{ 'Reason' | translate }}</th>
        <td mat-cell *matCellDef="let h">{{ h.reason || '-' }}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button type="button" (click)="close()">{{ 'Close' | translate }}</button>
</mat-dialog-actions>
